import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { StorageService } from '../storage/storage.service';
import { SessionStorageService } from '../storage/sessionstorage/sessionstorage.service';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  private BASE_API_URL_RDO: string = environment.BASE_API_URL_RDO;
  private BASE_API_RDO: string = environment.BASE_API_RDO;
  private internalRequest: boolean = false;

  constructor(
    private _http: HttpClient,
    private _storageService: SessionStorageService
  ) {}

  requestMethod(
    requestURL: string,
    method: string,
    itsInternal: boolean,
    data?: any,
    requestHeader?: any,
    responseType?: 'json' | 'blob'
  ): any {
    this.internalRequest = itsInternal;

    const url = itsInternal ? this.BASE_API_URL_RDO + requestURL : requestURL;

    const auth = this._storageService.buscarTokenAplicacao();

    let headers = new HttpHeaders(requestHeader || { 'Content-Type': 'application/json' });

    if (auth && itsInternal) {
      headers = headers.set('Authorization', `Bearer ${auth}`);
    }

    const options: any = { headers };

    if (responseType) {
      options.responseType = responseType;
    }

    switch (method.toUpperCase()) {
      case 'GET':
        return this.throughGet(url, options);
      case 'POST':
        return this.throughPost(url, data, options); 
      case 'PUT':
        return this.throughPut(url, data, options); 
      case 'DELETE':
        options.body = data;
        return this._http.request('DELETE', url, options);
      default:
        throw new Error(`Método HTTP não suportado: ${method}`);
    }
  }

  request(
    requestURL: string,
    method: string,
    itsInternal: boolean,
    data?: any,
    requestHeader?: any,
    responseType?: 'json' | 'blob'
  ): any {
    this.internalRequest = itsInternal;

    let url = itsInternal ? this.BASE_API_RDO + requestURL : requestURL;

    let auth = this._storageService.buscarTokenAplicacao();
    let header = requestHeader || {};

    if (auth && itsInternal) {
      header.Authorization = `Bearer ${auth}`;
    }

    let options: any = { headers: new HttpHeaders(header) };

    if (requestHeader?.responseType === 'blob') {
      options.responseType = 'blob';
    }

    if (responseType) {
      options.responseType = responseType;
    }

    if (data) {
      return method.toUpperCase() === 'CPOST'
        ? this.throughPost(url, data, options)
        : this.throughPost(url, data, options);
    } else {
      if (method.toUpperCase() === 'POST') {
        return this.throughPost(url, {}, options);
      } else {
        return this.throughGet(url, options);
      }
    }
  }

  requestMethodPromise(
    requestURL: string,
    method: string,
    itsInternal: boolean,
    data?: any,
    requestHeader?: any
  ): any {
    this.internalRequest = itsInternal;

    let url = itsInternal ? this.BASE_API_URL_RDO + requestURL : requestURL,
      auth = this._storageService.buscarTokenAplicacao(),
      header = requestHeader
        ? requestHeader
        : { 'Content-Type': 'application/json' };

    if (auth && itsInternal) header.Authorization = `Bearer ${auth}`;

    let option = { headers: header };
    if (data) {
      return method.toUpperCase() == 'CPOST'
        ? this.throughPostPromise(url, data, option)
        : this.throughPostPromise(url, data, option); 
    } else {
      return this.throughGetPromise(url, option);
    }
  }

  private throwObservableSuccess(dataToReturn: any) {
    return {
      success: true,
      message: null,
      data: dataToReturn,
    };
  }

  private throughPost(url: string, data: any, option?: any) {
    return this._http.post(url, data, option).pipe(
      map((response) => {
        return this.internalRequest
          ? response
          : this.throwObservableSuccess(response);
      })
    );
  }

  private throughPostPromise(url: string, data: any, option?: any) {
    return this._http
      .post(url, data, option)
      .pipe(
        map((response) => {
          return this.internalRequest
            ? response
            : this.throwObservableSuccess(response);
        })
      )
      .toPromise();
  }

  throughPut(url: string, data: any, options: any): any {
    return this._http.put(url, data, options);
  }

  private throughGet(url: string, option?: any) {
    return this._http.get(url, option).pipe(
      map((response) => {
        return this.internalRequest
          ? response
          : this.throwObservableSuccess(response);
      })
    );
  }

  private throughGetPromise(url: string, option?: any) {
    return this._http
      .get(url, option)
      .pipe(
        map((response) => {
          return this.internalRequest
            ? response
            : this.throwObservableSuccess(response);
        })
      )
      .toPromise();
  }

  delete(requestURL: string, itsInternal: boolean, requestHeader?: any): any {
    this.internalRequest = itsInternal;
    const url = itsInternal ? this.BASE_API_URL_RDO + requestURL : requestURL;
    const auth = this._storageService.buscarTokenAplicacao();
    let headers = new HttpHeaders(
      requestHeader || { 'Content-Type': 'application/json' }
    );
    if (auth && itsInternal) {
      headers = headers.set('Authorization', `Bearer ${auth}`);
    }
    const options = { headers };
    return this._http.delete(url, options).pipe(
      map((response) => {
        return this.internalRequest
          ? response
          : this.throwObservableSuccess(response);
      })
    );
  }
}